export const TEST_ID = 'selectChemicalMixField';
